import {
  GET_LIST_CHAT_ROOM,
  GET_LIST_CHAT_ROOM_SUCCESS,
  GET_LIST_CHAT_ROOM_FAILED,
  GET_UNREAD_CHAT_ROOMS_COUNT,
  GET_UNREAD_CHAT_ROOMS_COUNT_SUCCESS,
  GET_UNREAD_CHAT_ROOMS_COUNT_FAILED,
  RESET_UNREAD_CHAT_ROOMS_COUNT,
  RESET_LIST_CHAT_ROOM,

  GET_CHAT_ROOM_DETAIL,
  GET_CHAT_ROOM_DETAIL_SUCCESS,
  GET_CHAT_ROOM_DETAIL_FAILED,
  RESET_CHAT_ROOM_DETAIL,

  GET_CHAT_ROOM_MESSAGES,
  GET_CHAT_ROOM_MESSAGES_SUCCESS,
  GET_CHAT_ROOM_MESSAGES_FAILED,
  RESET_CHAT_ROOM_MESSAGES,

  SEND_CHAT_MESSAGE,
  SEND_CHAT_MESSAGE_SUCCESS,
  SEND_CHAT_MESSAGE_FAILED,
  SEND_CHAT_MESSAGE_COMPLETED,

  RECEIVE_CHAT_ROOM_MESSAGE,
  RECEIVE_NEW_CHAT_ROOM,
  READ_CHAT_ROOM_SUCCESS,
} from './actionTypes';

const initialState = {
  isLoadingChatRooms: false,
  chatRooms: [],
  chatRoomsTotal: 0,
  isLoadingUnreadChatRoomsCount: false,
  unreadChatRoomsCount: 0,
  unreadChatRoomsPlaceId: '',

  isLoadingChatRoomDetail: false,
  chatRoomDetail: null,

  isLoadingChatMessages: false,
  chatMessages: [],
  chatMessagesTotal: 0,

  isSendingChatMessage: false,
  sendingChatMessageCount: 0,
  sentMessageClientIds: [],
};

export default function chat(state = initialState, action) {
  switch (action.type) {
    case GET_LIST_CHAT_ROOM:
      return {
        ...state,
        isLoadingChatRooms: true,
      };

    case GET_LIST_CHAT_ROOM_SUCCESS:
      return {
        ...state,
        chatRooms: action.payload.isLoadMore
          ? [...state.chatRooms, ...action.payload.data]
          : action.payload.data,
        chatRoomsTotal: action.payload.total,
        isLoadingChatRooms: false,
      };

    case GET_LIST_CHAT_ROOM_FAILED:
      return {
        ...state,
        isLoadingChatRooms: false,
      };

    case GET_UNREAD_CHAT_ROOMS_COUNT:
      return {
        ...state,
        isLoadingUnreadChatRoomsCount: true,
      };

    case GET_UNREAD_CHAT_ROOMS_COUNT_SUCCESS:
      return {
        ...state,
        unreadChatRoomsCount: action.payload.count,
        unreadChatRoomsPlaceId: action.payload.place,
        isLoadingUnreadChatRoomsCount: false,
      };

    case GET_UNREAD_CHAT_ROOMS_COUNT_FAILED:
      return {
        ...state,
        isLoadingUnreadChatRoomsCount: false,
      };

    case RESET_UNREAD_CHAT_ROOMS_COUNT:
      return {
        ...state,
        unreadChatRoomsCount: 0,
        unreadChatRoomsPlaceId: action.payload?.place || state.unreadChatRoomsPlaceId,
        isLoadingUnreadChatRoomsCount: false,
      };

    case RESET_LIST_CHAT_ROOM:
      return {
        ...state,
        chatRooms: [],
        chatRoomsTotal: 0,
      };

    case GET_CHAT_ROOM_DETAIL:
      return {
        ...state,
        isLoadingChatRoomDetail: true,
      };

    case GET_CHAT_ROOM_DETAIL_SUCCESS:
      return {
        ...state,
        chatRoomDetail: action.payload,
        isLoadingChatRoomDetail: false,
      };

    case GET_CHAT_ROOM_DETAIL_FAILED:
      return {
        ...state,
        isLoadingChatRoomDetail: false,
      };

    case RESET_CHAT_ROOM_DETAIL:
      return {
        ...state,
        chatRoomDetail: null,
      };

    case GET_CHAT_ROOM_MESSAGES:
      return {
        ...state,
        isLoadingChatMessages: true,
        ...(action.payload.isLoadMore ? {} : { chatMessages: [] }),
      };

    case GET_CHAT_ROOM_MESSAGES_SUCCESS:
      return {
        ...state,
        chatMessages: action.payload.isLoadMore
          ? [...state.chatMessages, ...action.payload.data]
          : action.payload.data,
        chatMessagesTotal: action.payload.total,
        isLoadingChatMessages: false,
      };

    case GET_CHAT_ROOM_MESSAGES_FAILED:
      return {
        ...state,
        isLoadingChatMessages: false,
      };

    case RESET_CHAT_ROOM_MESSAGES:
      return {
        ...state,
        chatMessages: [],
        chatMessagesTotal: 0,
        sentMessageClientIds: [],
      };

    case SEND_CHAT_MESSAGE:
      return {
        ...state,
        isSendingChatMessage: true,
        sendingChatMessageCount: state.sendingChatMessageCount + 1,
      };

    case SEND_CHAT_MESSAGE_SUCCESS: {
      const isDuplicate = state.chatMessages.some(
        (message) => message._id === action.payload.message._id,
      );

      if (isDuplicate) {
        return {
          ...state,
          sentMessageClientIds: action.payload.clientId
            ? [...state.sentMessageClientIds, action.payload.clientId]
            : state.sentMessageClientIds,
        };
      }

      return {
        ...state,
        chatMessages: [action.payload.message, ...state.chatMessages],
        chatMessagesTotal: state.chatMessagesTotal + 1,
        sentMessageClientIds: action.payload.clientId
          ? [...state.sentMessageClientIds, action.payload.clientId]
          : state.sentMessageClientIds,
      };
    }

    case SEND_CHAT_MESSAGE_FAILED:
      return state;

    case SEND_CHAT_MESSAGE_COMPLETED: {
      const sendingChatMessageCount = Math.max(
        state.sendingChatMessageCount - 1,
        0,
      );

      return {
        ...state,
        sendingChatMessageCount,
        isSendingChatMessage: sendingChatMessageCount > 0,
      };
    }

    case RECEIVE_CHAT_ROOM_MESSAGE: {
      const isDuplicate = state.chatMessages.some(
        (message) => message._id === action.payload._id,
      );

      if (isDuplicate) {
        return state;
      }

      return {
        ...state,
        chatMessages: [action.payload, ...state.chatMessages],
        chatMessagesTotal: state.chatMessagesTotal + 1,
      };
    }

    case RECEIVE_NEW_CHAT_ROOM: {
      const newRoom = action.payload;
      const existingRoom = state.chatRooms.find(
        (room) => room._id === newRoom._id,
      );

      if (existingRoom) {
        return {
          ...state,
          chatRooms: [
            newRoom,
            ...state.chatRooms.filter((room) => room._id !== newRoom._id),
          ],
        };
      }

      return {
        ...state,
        chatRooms: [newRoom, ...state.chatRooms],
        chatRoomsTotal: state.chatRoomsTotal + 1,
      };
    }

    case READ_CHAT_ROOM_SUCCESS:
      return {
        ...state,
        chatRooms: state.chatRooms.map((room) => (
          room._id === action.payload.id
            ? { ...room, isRead: true }
            : room
        )),
      };

    default:
      return state;
  }
}
